module.exports = __webpack_public_path__ + "static/media/main_page.20ec0489.png";